
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M41.626 23c.4 0 .766-.236.895-.614.31-.9.479-1.873.479-2.886 0-4.694-3.624-8.5-8.095-8.5a.26.26 0 0 1-.23-.137C32.468 6.766 28.28 4 23.476 4c-6.043 0-11.113 4.378-12.488 10.278A6 6 0 0 0 9.19 14C5.772 14 3 16.91 3 20.5c0 .645.09 1.269.256 1.858.112.394.487.642.897.642H16V13h11.5l5.5 5.5V23zM18 40h1v3h-1zM21 39h1v4h-1zM30 39h1v2h-1zM25 41h1v4h-1zM31 42h-1v3h1zM21 44h1v2h-1z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Rectangle 7",attrs:{"stroke":"#234652","d":"M16 36h17V20.5L27.5 15H16z"}}),_c('path',{staticClass:"i-Rectangle 9",attrs:{"stroke":"#234652","d":"M27 15v6h6"}}),_c('path',{staticClass:"i-Subtract",attrs:{"stroke":"#234652","d":"M35.5 21h7.126c.4 0 .766-.236.895-.614.31-.9.479-1.873.479-2.886 0-4.694-3.624-8.5-8.095-8.5a.26.26 0 0 1-.23-.137C33.468 4.766 29.28 2 24.476 2c-6.043 0-11.113 4.378-12.488 10.278A6 6 0 0 0 10.19 12C6.77 12 4 14.91 4 18.5c0 .645.09 1.269.256 1.858.112.394.487.642.897.642H13"}}),_c('path',{staticClass:"i-Rectangle 38",attrs:{"stroke":"#234652","d":"m28 27.67-3.457-3.456-3.457 3.457"}}),_c('path',{staticClass:"i-Line 33",attrs:{"stroke":"#234652","d":"M24.5 25v7"}})])
          )
        }
      }
    